import {useEffect, useMemo, useState} from "react";
import {useWhatChanged} from "@simbathesailor/use-what-changed";

export type SearchParamsType<T = string> = { value: T, regex: boolean };

/**
 * usePagination
 * @param defaultPage pagina iniziale (normalmente la prima) N.B da uno a n
 * @param defaultPageLength lunghezza pagina (quante righe per pagina)
 */
export function usePagination<T = string>(initialState: T, defaultPage: number = 1, defaultPageLength: number = 25,) {
    const [searchParams, setSearchParams] = useState<SearchParamsType<T> | undefined>();
    const [search, setSearch] = useState<T>(initialState);
    const [serverSide, setServerSide] = useState<boolean>(true);
    const [hasSearch, setHasSearch] = useState<boolean>(true);
    const [page, setPage] = useState<number>(defaultPage);
    const [pageLength, _setPageLength] = useState<number>(defaultPageLength);

    useEffect(() => {
        setPage(1);
        if (search) {
            setSearchParams({value: search, regex: false});
        } else
            setSearchParams(undefined);
    }, [search]);

    const setPageLength = (length: number) => {
        setPage(1);
        _setPageLength(length);
    }

    /**
     * es. se pagina uno allora zero, se pagina due e lunghezza pagina pari a 10 allora 10...
     * @param currentPage
     * @param currentPageLength
     */
    const page2Start = (currentPage: number, currentPageLength: number) => {
        return ((currentPage - 1) * currentPageLength);
    }

    //useWhatChanged([hasSearch, page, pageLength, search, searchParams, serverSide,]);

    return useMemo(() => {
        return {
            search,
            setSearch: hasSearch ? setSearch : undefined,
            page,
            setPage,
            pageLength, setPageLength,
            getStart: () => page2Start(page, pageLength),
            page2Start,
            getSearchParams: () => searchParams,
            serverSide, setServerSide,
            setHasSearch
        }
    }, [hasSearch, page, pageLength, search, searchParams, serverSide]);
}

export type PaginationReturnType<T = string> = ReturnType<typeof usePagination<T>>;
